// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

// @ts-ignore
import { RapidReviewEncounterResponse } from './rapid-review-encounter-response';

// @ts-ignore
import { RapidReviewInsuranceResponse } from './rapid-review-insurance-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewHeaderResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewHeaderResponse extends GandalfModelBase {

	@GandalfArray(RapidReviewEncounterResponse)
	encounters!: RapidReviewEncounterResponse[];

	@GandalfArray(RapidReviewInsuranceResponse)
	insurances!: RapidReviewInsuranceResponse[];

	@GandalfProperty({ designType: PatientNameResponse })
	patient!: PatientNameResponse;

}
